import React, { useCallback, useState } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';
import Modal from 'buyside/components/presentation/Modal/modal';

import { allocatorProfileUrl, requestAccessToCapIntroUrl } from 'buyside/util/urlHelper';
import PieChartIcon from 'buyside/svgs/pie_chart.svg';

import { ActivityFeedAllocatorProfileFragment } from 'interfaces/graphql-typings';

const vowelTest = (s: string): boolean => {
  return /^[aeiou]$/i.test(s);
};

import styles from './newAllocatorAnonymousStyles.scss';

const NewAllocatorAnonymous: React.FC<{ allocator: ActivityFeedAllocatorProfileFragment }> = ({
  allocator
}): React.ReactElement => {
  const [isViewAllocatorModalOpen, setIsViewAllocatorModalOpen] = useState(false);

  const { id, aumRange, employerType, location, publicBio } = allocator;

  let isVowel = false;
  if (location) {
    isVowel = vowelTest(location[0]);
  }
  let quoteText =
    'The SumZero Cap Intro platform offers funds seeking new capital the opportunity to get direct exposure to pre-vetted, high-quality institutional allocators that are actively allocating to funds, particularly small and emerging managers.';
  if (publicBio) {
    quoteText = publicBio;
  }

  const renderOpenViewAllocatorModalButton = useCallback(
    () => <Button onClick={() => setIsViewAllocatorModalOpen(true)} text="View Allocator" />,
    []
  );

  //currently allocators do not have a public bio
  return (
    <div className={styles.newAllocatorAnonymous}>
      <p>
        <PieChartIcon className={styles.pieChartIcon} />
        <Link to={allocatorProfileUrl(id)}>
          {isVowel ? 'An' : 'A'} {location ? location : 'N/A'}-Based {aumRange ? aumRange : ''}{' '}
          {employerType}
        </Link>{' '}
        has joined SumZero as a Capital Allocator
      </p>
      <blockquote>{quoteText}</blockquote>
      <div>
        <Modal
          isOpen={isViewAllocatorModalOpen}
          onClose={() => setIsViewAllocatorModalOpen(false)}
          renderOpenModalButton={renderOpenViewAllocatorModalButton}
          size="lg"
          title="View Allocator"
        >
          <div>
            <h3>Request Access to SumZero Cap Intro</h3>
            <p>
              You do not currently have access to the Cap Intro platform. Click below to confirm
              that you would like to request access to the SumZero Cap Intro platform.
            </p>
            <Button
              text="Request Access to Cap Intro"
              type={BUTTON_TYPES.PRIMARY}
              url={requestAccessToCapIntroUrl()}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default NewAllocatorAnonymous;
